var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnection = function SvgConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625.5A1.875 1.875 0 0 1 15.5 2.375v11.25a1.875 1.875 0 1 1-3.75 0V2.375A1.875 1.875 0 0 1 13.625.5ZM8 4.25a1.875 1.875 0 0 1 1.875 1.875v7.5a1.875 1.875 0 1 1-3.75 0v-7.5A1.875 1.875 0 0 1 8 4.25ZM2.375 9.875A1.875 1.875 0 0 1 4.25 11.75v1.875a1.875 1.875 0 1 1-3.75 0V11.75a1.875 1.875 0 0 1 1.875-1.875Z",
    fill: "#fff"
  })));
};
export default SvgConnection;